import Vue from "vue";
import store from "@/store";
import decidir from "@/services/gateways/decidir";
import errors from "@/services/errors";

export default {
  //envia un token o los cardDetails. si esta el token de la saved card entonces se llama al servicio /token de decidir con el token permanente de la tarjeta.
  createTempToken: async (gatewayId, gatewayPublicKey, token, cardDetails) => {
    try {
      let payload, tempToken;
      const x = 10;
      //es una tarjeta ya existente
      if (gatewayId == 1) {
        //decidir
        const tokenRes = await decidir.createTempToken(
          gatewayPublicKey,
          token,
          cardDetails
        );
        if (tokenRes.status != 201) {
          tokenRes.errorName = "DecidirGatewayError";
          const err = errors.handleHTTPError(tokenRes);
          throw err;
        }
        tempToken = tokenRes.data.id;
      } else if (gatewayId == 2) {
        //paguelo-facil
        tempToken = cardDetails.cardNumber.replace(/\s+/g, ""); //card number with remove blank spaces
        //console.log(`tempToken: ${tempToken}
        //cardDetails: ${cardDetails.cardNumber}`);
      }
      // } else if (gatewayId == 3) {
      //   //cielo
      //   tempToken = cardDetails.cardNumber.replace(/\s+/g, ""); //card number with remove blank spaces
      // }
      const y = 20;
      return tempToken;
    } catch (err) {
      //console.log(`Gateway err: ${err}`);
      throw err;
    }
  },
  getCardType(id) {
    const cardTypes = {
      "1": "Visa",
      "104": "MasterCard",
      "65": "American Express",
      "30": "ArgenCard",
      "50": "BBPS",
      "27": "Cabal",
      "63": "Cabal Prisma",
      "34": "CoopePlus",
      "62": "CrediGuia",
      "38": "Credimás",
      "8": "Diners Club",
      "60": "Distribution",
      "103": "Favacard",
      "54": "Grupar",
      "29": "Italcred",
      "42": "Nativa",
      "37": "Nexo",
      "55": "Patagonia 365",
      "52": "Qida",
      "44": "Tarjeta Carrefour / Cetelem",
      "43": "Tarjeta Cencosud",
      "56": "Tarjeta Club Día",
      "61": "Tarjeta La Anónima",
      "24": "Tarjeta Naranja",
      "39": "Tarjeta Nevada",
      "45": "Tarjeta PymeNacion",
      "23": "Tarjeta Shopping",
      "64": "Tarjeta SOL",
      "59": "Tuya",
      "31": "Visa [Débito]",
      "67": "Cabal [Débito]",
      "106": "Maestro",
      "105": "MasterCard [Débito]",
      "108": "Cabal [Débito]"
    };
    return cardTypes[id];
  },
  humanizeDecidirError(error) {
    let message;
    if (error.error_type && error.error_type == "invalid_request_error") {
      message = "Error de validación:";
      if (error.validation_errors) {
        error.validation_errors.forEach(element => {
          if (element.code == "invalid_param" && element.param == "card_number")
            message += `
              Número de tarjeta es inválido.`;
          else if (element.code == "invalid_param" && element.param == "bin")
            message += `
              El número de tarjeta no coincide con la tarjeta seleccionada.`;
          else if (element.code == "invalid_param" && element.param)
            message += `
              Dato Inválido: ${element.param}`;
          else
            message += `
            ${element.code}: ${element.param}`;
        });
      }
    } else if (error.error_type && error.error_type == "not_found_error") {
      message = `No se encontró la tarjeta.`;
      if (error.entity_name == "OperationResource")
        message = `Falló el proceso de validación de tarjeta.`;
    } else if (error.status && error.status == "rejected") {
      message = `Tarjeta Rechazada.`;
      if (error.status_details)
        if (error.status_details.error)
          if (error.status_details.error.reason)
            if (error.status_details.error.reason.description) {
              message += `
              Motivo: ${error.status_details.error.reason.description}
              Nro de Ticket: ${error.status_details.ticket}`;
            }
    } else {
      message = `Hubo un error al procesar la tarjeta: 
      ${JSON.stringify(error)}`;
    }
    return message;
  }
};
